import { LINKS, Usd } from "@silo/types";
import { match, P } from "ts-pattern";
import { cn } from "../../utils/class-names";
import { asCompactUsd } from "@silo/utils";
import { Link, UnstyledLink } from "../link";
import { ExternalLinkIcon } from "../../icons";
import { SkeletonWrapper } from "../skeleton";

interface TvlDisplayProps {
  isTvlEnabled: boolean;
  tvl: Usd | null;
  className?: string;
}

export function TvlDisplay({
  className,
  isTvlEnabled,
  tvl,
}: TvlDisplayProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex px-5 py-2.5 sm:py-2.5 rounded-lg w-fit bg-shale-800 gap-5 divide-x divide-shale-700 items-center",
        className
      )}
    >
      <div className="flex items-center gap-5">
        <div className="text-base text-shale-200 whitespace-nowrap">TVL</div>
        <div
          className="text-2xl font-medium text-white lowercase whitespace-nowrap"
          data-cy="total-value-locked"
        >
          {match({ isTvlEnabled, tvl })
            .with({ isTvlEnabled: false }, () => "--")
            .with({ tvl: P.nonNullable }, ({ tvl }) => asCompactUsd(tvl))
            .otherwise(() => (
              <SkeletonWrapper className="bg-shale-750 animate-pulse">
                $100m
              </SkeletonWrapper>
            ))}
        </div>
      </div>

      <div className="flex pl-5 justify-self-center">
        <UnstyledLink
          href={LINKS.SILO_OBSERVER}
          external
          className="flex justify-center gap-2.5 items-center px-1 mx-auto font-medium"
        >
          Analytics
          <ExternalLinkIcon className="w-4 h-4 text-shale-400" />
        </UnstyledLink>
      </div>
    </div>
  );
}
